import { formatMoney } from '@betterment/js-runtime';
import { Box, Text } from '@betterment/samba-react';

import { DividendItem } from '../../transactionTypes/Dividend';

export const DividendPayout: React.FC<{ item: DividendItem }> = ({ item }) => {
  const name = item.security?.name;
  const symbol = item.security?.symbol;
  const amount = formatMoney(item.amount);

  return (
    <Box css={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', gap: 'space.300' }}>
      <Text variant="text100" color="text.weak">
        {symbol} • {name}
      </Text>
      <Text variant="text100" color="text.weak">
        {amount}
      </Text>
    </Box>
  );
};
